export default __webpack_public_path__ + "static/media/purple-send.9c6af1a3.svg";